module.exports = __webpack_public_path__ + "static/img/p5_bg1@2x.3d9ab74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/go/p5_bg1@2x.jpg
// module id = 95
// module chunks = 0